import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { AccountService } from '../../../services/account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/account.service";
export class AreaTecnicaService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getAreasTecnicas() {
        return this.http.get(`${SCAMP_API.accountApiV1}/areas-tecnicas-cb`, { headers: this.account.composeHeaders() });
    }
    setOutraAreaTecnica(dado) {
        return this.http.post(`${SCAMP_API.accountApiV1}/outra-area-tecnica`, dado, { headers: this.account.composeHeaders() });
    }
    isUniqueNomeAreaTecnica(nome) {
        return this.http.post(`${SCAMP_API.accountApiV1}/nome-areatecnica-is-unique`, { nome }, { headers: this.account.composeHeaders() });
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/areatecnica`, data, { headers: this.account.composeHeaders() });
    }
    read(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/areatecnica/${id}`, { headers: this.account.composeHeaders() });
    }
    update(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/areatecnica/${id}`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/areatecnica/${id}`, { headers: this.account.composeHeaders() });
    }
    list() {
        return this.http.get(`${SCAMP_API.accountApiV1}/areastecnicas`, { headers: this.account.composeHeaders() });
    }
}
AreaTecnicaService.ngInjectableDef = i0.defineInjectable({ factory: function AreaTecnicaService_Factory() { return new AreaTecnicaService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: AreaTecnicaService, providedIn: "root" });
